import { Slider } from '@mui/material'
import React from 'react'
import HeaderTeam from '../Components/Team/HeaderTeam'
import SliderAllTeam from '../Components/Team/SliderAllTeam'
const Team = () => {
  return (
    <div>
        <HeaderTeam/>
        <SliderAllTeam/>
    </div>
  )
}

export default Team